export default "__VITE_PUBLIC_ASSET__10f8739c__"